import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { mockPRs } from '../data/mockData';
import { EOIPanel } from '../components/procurement/EOIPanel';
import { StatusBadge } from '../components/StatusBadge';
export function EOIAction() {
  const {
    id
  } = useParams<{
    id: string;
  }>();
  const navigate = useNavigate();
  const pr = mockPRs.find(p => p.id === id);
  if (!pr) {
    return <div className="flex flex-col items-center justify-center h-full" data-id="element-728">
        <h2 className="text-xl font-bold text-gray-900" data-id="element-729">PR not found</h2>
        <button onClick={() => navigate('/eoi')} className="mt-4 text-indigo-600 hover:text-indigo-800" data-id="element-730">
          Back to EOI List
        </button>
      </div>;
  }
  return <div className="max-w-6xl mx-auto space-y-6 pb-12" data-id="element-731">
      {/* Header */}
      <div className="flex items-center justify-between" data-id="element-732">
        <div className="flex items-center space-x-4" data-id="element-733">
          <button onClick={() => navigate('/eoi')} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors" data-id="element-734">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-735" />
          </button>
          <div data-id="element-736">
            <div className="flex items-center space-x-3" data-id="element-737">
              <h1 className="text-2xl font-bold text-gray-900 tracking-tight" data-id="element-738">
                Process EOI
              </h1>
              <StatusBadge status="Draft" data-id="element-739" />
            </div>
            <p className="text-sm text-gray-500 mt-1" data-id="element-740">
              Expression of Interest for {pr.prNo}
            </p>
          </div>
        </div>
      </div>

      {/* PR Context Card */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-5 flex flex-wrap gap-6" data-id="element-741">
        <div data-id="element-742">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-743">
            PR Number
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-744">{pr.prNo}</p>
        </div>
        <div data-id="element-745">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-746">
            Originator
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-747">
            {pr.originator}
          </p>
        </div>
        <div data-id="element-748">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-749">
            Method
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-750">
            {pr.procurementMethod}
          </p>
        </div>
        <div data-id="element-751">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-752">
            Total Amount
          </p>
          <p className="mt-1 text-sm font-medium text-gray-900" data-id="element-753">
            ${pr.total.toLocaleString()}
          </p>
        </div>
      </div>

      {/* Embedded Panel */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-6" data-id="element-754">
        <EOIPanel data-id="element-755" />
      </div>
    </div>;
}